import React from "react";
import styles from "./style.module.css";

import "react-toggle/style.css";
import Toggle from "react-toggle";

export default class LabledToggle extends React.PureComponent {
  render() {
    const { checked, onChange, trueLabel, falseLabel, isAibleColors, className, disabled, ...retProps } = this.props;

    const retTrueLabel = trueLabel !== undefined ? trueLabel : "Yes";
    const retFalseLabel = falseLabel !== undefined ? falseLabel : "No";

    return (
      <div id={"eToggle"} className={styles.tHolder + " " + (className ? className : "")} {...retProps}>
        <Toggle
          checked={checked}
          icons={false}
          onChange={onChange}
          className={isAibleColors ? (checked ? styles.aibleYes : styles.aibleNo) : undefined}
          disabled={disabled}
        />
        <span className={checked ? (isAibleColors ? styles.aibleYPos : styles.yPos) : styles.nPos}>
          {checked ? retTrueLabel : retFalseLabel}
        </span>
      </div>
    );
  }
}
